import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
	selector: 'app-icon',
	imports: [],
	standalone: true,
	templateUrl: './icon.component.html',
	styleUrl: './icon.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent {
	@Input() name!: string;
	@Input() size = 24;
	@Input() width?: number;
	@Input() height?: number;
	@Input() cssClass = '';
	@Input() viewBox = '0 0 24 24';

	getSvgWidth(): number {
		return this.width ?? this.size ?? 24;
	}

	getSvgHeight(): number {
		return this.height ?? this.size ?? 24;
	}

	/**
	 * Get the appropriate viewBox for the icon
	 */
	getViewBox(): string {
		switch (this.name) {
			case 'arrow-right':
				return '0 0 13 10';
			case 'eyeIcon':
				return '0 0 20 11.25';
			case 'eyeOff':
				return '0 0 20 11.25';
			case 'chevronRight':
				return '0 0 64 64';
			case 'logo-48':
				return '0 0 48 48';
			default:
				return this.viewBox;
		}
	}
}

// Type safety for icon names
export type IconName =
	| 'user'
	| 'loading'
	| 'error'
	| 'warning'
	| 'info'
	| 'success'
	| 'refresh'
	| 'empty'
	| 'arrow-right'
	| 'arrow-down'
	| 'trash'
	| 'file'
	| 'external-link'
	| 'copy'
	| 'hide'
	| 'show'
	| 'close'
	| 'menu'
	| 'user-18'
	| 'user-24'
	| 'logout'
	| 'filter'
	| 'world'
	| 'chevronRight'
	| 'codeFile'
	| 'renewArrow'
	| 'eyeIcon'
	| 'eyeOff'
	| 'socialFacebook'
	| 'socialTwitter'
	| 'socialLinkedIn'
	| 'socialYouTube'
	| 'socialInstagram'
	| 'socialTikTok'
	| 'logo'
	| 'logoTypo';
